var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr'})},[(_vm.params.data.status !== 0)?_c('vs-button',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.setEndOfHole()}}},[_vm._v(_vm._s(_vm.params.data.status === 2 ? _vm.$t('Drilling.Holes.ReverseEndOfHole') : _vm.$t('Drilling.Holes.EndOfHole')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }